var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 333,
    viewBox: "0 0 508 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.111 0H0.111108C0.111108 3.33333 -0.888877 13.5 3.11111 25C8.12574 39.4171 13.1111 50 25.1111 61C37.1111 72 60.1111 81 72.1111 84C84.1111 87 126.111 94 143.111 94C160.111 94 198.111 99 214.111 100C230.111 101 249.111 105 267.111 108C285.111 111 298.045 118.007 306.111 123C316.611 129.5 332.111 140 342.111 154C354.232 170.969 358.111 186 365.111 207C370.711 223.8 386.111 252.667 394.111 266C399.444 274.667 414.511 294.6 440.111 313C465.711 331.4 495.778 334 507.111 332V0Z",
    fill: "url(#paint0_linear_30_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_3",
    x1: 253.556,
    y1: -0.00000113104,
    x2: 266,
    y2: 303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2589EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516704,
    stopColor: "#2328EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0102FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTop);
export default __webpack_public_path__ + "static/media/VectorTop.916102d90ecd7abfb684edd1af6350d9.svg";
export { ForwardRef as ReactComponent };